import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[preventNonNumeric]'
})
export class PreventNonNumericDirective {
  constructor() {
  }

  // numerical inputs allow the user to type the letter 'e' in them, because it is a scientific notation (stands for exponent of 10)
  // SJ want to stop this happening though, so we can add this directive to any input to stop that
  @HostListener('keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'e') {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  blockPaste(event: any) {
    const pastedText = event.clipboardData.getData('text/plain');

    if (pastedText.includes('e')) {
      event.preventDefault();
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/prevent-non-numeric.ts